import { request } from "@/libs";
const timeout = 8000;

export default function resetPassword({ id, nonce, password }) {
	return request("/server/password-reset",
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ id, nonce, password })
		},
		timeout
	);
}



// WEBPACK FOOTER //
// ./src/api/reset-password.js